/**
 * Angular dependencies
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


/**
 * App dependencies
 */
import { AlertIconComponent } from '@shared/components/icons/alert-icon/alert-icon.component';
import { BrokenImageIconComponent } from '@shared/components/icons/broken-image-icon/broken-image-icon.component';
import { CaretIconComponent } from '@shared/components/icons/caret-icon/caret-icon.component';
import { ChevronIconComponent } from '@shared/components/icons/chevron-icon/chevron-icon.component';
import { CloseIconComponent } from '@shared/components/icons/close-icon/close-icon.component';
import { ExternalLinkIconComponent } from '@shared/components/icons/external-link-icon/external-link-icon.component';
import { HelpIconComponent } from '@shared/components/icons/help-icon/help-icon.component';
import { ResetIconComponent } from '@shared/components/icons/reset-icon/reset-icon.component';
import { WarningIconComponent } from '@shared/components/icons/warning-icon/warning-icon.component';
import { ClipboardIconComponent } from './clipboard-icon/clipboard-icon.component';


@NgModule({
  declarations: [
    AlertIconComponent,
    BrokenImageIconComponent,
    CaretIconComponent,
    ChevronIconComponent,
    ClipboardIconComponent,
    CloseIconComponent,
    ExternalLinkIconComponent,
    HelpIconComponent,
    ResetIconComponent,
    WarningIconComponent
  ],
  exports: [
    AlertIconComponent,
    BrokenImageIconComponent,
    CaretIconComponent,
    ChevronIconComponent,
    ClipboardIconComponent,
    CloseIconComponent,
    ExternalLinkIconComponent,
    HelpIconComponent,
    ResetIconComponent,
    WarningIconComponent
  ],
  imports: [
    CommonModule
  ]
})
export class IconsModule { }
